// extracted by mini-css-extract-plugin
module.exports = {"container":"DataViewLoading_container","label":"DataViewLoading_label"};